import * as React from 'react';

export interface FieldAccessibility {
  id: string;
  explicit?: boolean;
  labelId: string;
  descriptionId?: string;
  required?: boolean;
  invalid?: boolean;
}
export const FieldAccessibilityContext = React.createContext<FieldAccessibility | null>(null);

type ControlProps = Pick<React.InputHTMLAttributes<HTMLInputElement>, 'id' | 'aria-label' | 'aria-labelledby' | 'aria-describedby' | 'aria-invalid' | 'aria-required'>;
export function fieldAttributes(field: FieldAccessibility | null, props: ControlProps): ControlProps {
  if (!field) return props;
  // Compound fields (DDI + phone, date + time) have independent accessible names.
  // Connect only the intended control; do not copy its id/name to every descendant.
  if ((props.id && props.id !== field.id) || (!props.id && (field.explicit || props['aria-label']))) return props;
  return {
    id: props.id ?? field.id,
    'aria-labelledby': props['aria-labelledby'] ?? (props['aria-label'] ? undefined : field.labelId),
    'aria-describedby': [...new Set([props['aria-describedby'], field.descriptionId].filter(Boolean))].join(' ') || undefined,
    'aria-invalid': props['aria-invalid'] ?? (field.invalid || undefined),
    'aria-required': props['aria-required'] ?? (field.required || undefined),
  };
}
export function useFieldAttributes(props: ControlProps) {
  return fieldAttributes(React.useContext(FieldAccessibilityContext), props);
}
